"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomString = void 0;
function RandomString(length) {
    const result = [];
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        const char = characters.charAt(Math.floor(Math.random() * characters.length));
        result.push(char);
    }
    return result.join('');
}
exports.RandomString = RandomString;
//# sourceMappingURL=RandomString.js.map